import { createBrowserRouter, Navigate } from "react-router-dom";

import { AppShell } from "../components/app-shell/AppShell";
import { ProtectedRoute } from "../components/app-shell/ProtectedRoute";

import DashboardPage from "#/features/dashboard/pages/DashboardPage";

import LoginPage from "#/features/auth/pages/LoginPage";
import ForgotPasswordPage from "#/features/auth/pages/ForgotPasswordPage";
import ResetPasswordPage from "#/features/auth/pages/ResetPasswordPage";
import ChangePasswordPage from "#/features/auth/pages/ChangePasswordPage";
import AccountSecurityPage from "#/features/auth/pages/AccountSecurityPage";

import UsersPage from "#/features/users/pages/UsersPage";
import UserViewPage from "#/features/users/pages/UserViewPage";

import EmployeesPage from "#/features/employees/pages/EmployeesPage";
import EmployeeCreatePage from "#/features/employees/pages/EmployeeCreatePage";
import EmployeeEditPage from "#/features/employees/pages/EmployeeEditPage";
import EmployeeViewPage from "#/features/employees/pages/EmployeeViewPage";

import RolesPage from "#/features/roles/pages/RolesPage";
import RoleCreatePage from "#/features/roles/pages/RoleCreatePage";
import RoleEditPage from "#/features/roles/pages/RoleEditPage";
import RoleViewPage from "#/features/roles/pages/RoleViewPage";

import PermissionPage from "#/features/permissions/pages/PermissionPage";
import BusinessCardPage from "#/features/business-cards/pages/BusinessCardPage";
import CalendarAdminPage from "#/features/calendar/pages/CalendarAdminPage";
import NoticeAdminPage from "#/features/notices/pages/NoticeAdminPage";
import AuditLogPage from "#/features/audit/pages/AuditLogPage";
import NotificationInboxPage from "#/features/notifications/pages/NotificationInboxPage";
import NotificationsPage from "#/features/notifications/pages/NotificationsPage";
import ApprovalInboxPage from "#/features/approvals/pages/ApprovalInboxPage";

import DocumentsPage from "#/features/documents/pages/DocumentsPage";
import MyDocumentsPage from "#/features/self-service/pages/MyDocumentsPage";

import TrainingDashboardPage from "#/features/training/pages/TrainingDashboardPage";
import TrainingEnrollmentsPage from "#/features/training/pages/TrainingEnrollmentsPage";
import TrainingCourseCreatePage from "#/features/training/pages/TrainingCourseCreatePage";
import TrainingCourseViewPage from "#/features/training/pages/TrainingCourseViewPage";
import TrainingCourseEditPage from "#/features/training/pages/TrainingCourseEditPage";
import TrainingCoursesPage from "#/features/training/pages/TrainingCoursesPage";
import TrainingSessionsPage from "#/features/training/pages/TrainingSessionsPage";
import TrainingAttendancePage from "#/features/training/pages/TrainingAttendancePage";
import TrainingReportsPage from "#/features/training/pages/TrainingReportsPage";
import TrainingInboxPage from "#/features/training/pages/TrainingInboxPage";
import TrainingSetupPage from "#/features/training/pages/TrainingSetupPage";
import TrainingProgramsPage from "#/features/training/pages/TrainingProgramsPage";
import TrainingProgramCreatePage from "#/features/training/pages/TrainingProgramCreatePage";
import TrainingProgramViewPage from "#/features/training/pages/TrainingProgramViewPage";

import ClaimsDashboardPage from "#/features/claims/pages/ClaimsDashboardPage";
import MyClaimsPage from "#/features/claims/pages/MyClaimsPage";
import AdminClaimsPage from "#/features/claims/pages/AdminClaimsPage";
import ClaimsApprovalPage from "#/features/claims/pages/ClaimsApprovalPage";
import PaidClaimsPage from "#/features/claims/pages/PaidClaimsPage";
import ClaimsReportsPage from "#/features/claims/pages/ClaimsReportsPage";
import ClaimDetailsPage from "#/features/claims/pages/ClaimDetailsPage";
import ClaimCreatePage from "#/features/claims/pages/ClaimCreatePage";
import ClaimEditPage from "#/features/claims/pages/ClaimEditPage";

import WorkflowsPage from "#/features/workflows/pages/WorkflowsPage";
import WorkflowCreatePage from "#/features/workflows/pages/WorkflowCreatePage";
import WorkflowDetailsPage from "#/features/workflows/pages/WorkflowDetailsPage";
import WorkflowEditPage from "#/features/workflows/pages/WorkflowEditPage";
import WorkflowDelegationsPage from "#/features/workflows/pages/WorkflowDelegationsPage";

import MembershipPortalPage from "#/features/membership/pages/MembershipPortalPage";
import MemberCreatePage from "#/features/membership/pages/MemberCreatePage";
import MemberDetailsPage from "#/features/membership/pages/MemberDetailsPage";
import MemberEditPage from "#/features/membership/pages/MemberEditPage";
import MembershipConfigPage from "#/features/membership/pages/MembershipConfigPage";
import MembershipUploadPage from "#/features/membership/pages/MembershipUploadPage";
import MembershipReportsPage from "#/features/membership/pages/MembershipReportsPage";
import MembershipManagePage from "#/features/membership/pages/MembershipManagePage";

import InventoryDashboardPage from "#/features/inventory/pages/InventoryDashboardPage";
import InventoryItemsPage from "#/features/inventory/pages/InventoryItemsPage";
import InventoryItemCreatePage from "#/features/inventory/pages/InventoryItemCreatePage";
import InventoryItemEditPage from "#/features/inventory/pages/InventoryItemEditPage";
import InventoryItemViewPage from "#/features/inventory/pages/InventoryItemViewPage";
import InventoryImportPage from "#/features/inventory/pages/InventoryImportPage";
import InventoryCategoriesPage from "#/features/inventory/pages/InventoryCategoriesPage";
import InventoryReportsPage from "#/features/inventory/pages/ProcurementReportsPage";

import DepartmentsPage from "#/features/departments/pages/DepartmentsPage";
import DepartmentCreatePage from "#/features/departments/pages/DepartmentCreatePage";
import DepartmentEditPage from "#/features/departments/pages/DepartmentEditPage";

import AirtimePortalPage from "#/features/airtime/pages/AirtimePortalPage";
import AirtimeConfigPage from "#/features/airtime/pages/AirtimeConfigPage";
import AirtimeAllocationsPage from "#/features/airtime/pages/AirtimeAllocationsPage";
import AirtimeEmployeePage from "#/features/airtime/pages/AirtimeEmployeePage";
import AirtimeBatchesPage from "#/features/airtime/pages/AirtimeBatchesPage";

import ProcurementDashboard from "#/features/procurement/pages/ProcurementDashboard";
import ProcurementReportsPage from "#/features/procurement/pages/ProcurementReportsPage";
import RequisitionListPage from "#/features/procurement/pages/requisitions/RequisitionListPage";
import RequisitionCreatePage from "#/features/procurement/pages/requisitions/RequisitionCreatePage";
import RequisitionViewPage from "#/features/procurement/pages/requisitions/RequisitionViewPage";
import RFQListPage from "#/features/procurement/pages/rfqs/RFQListPage";
import RFQCreatePage from "#/features/procurement/pages/rfqs/RFQCreatePage";
import RFQViewPage from "#/features/procurement/pages/rfqs/RFQViewPage";
import EvaluationListPage from "#/features/procurement/pages/evaluations/EvaluationListPage";
import EvaluationCreatePage from "#/features/procurement/pages/evaluations/EvaluationCreatePage";
import EvaluationViewPage from "#/features/procurement/pages/evaluations/EvaluationViewPage";
import LPOListPage from "#/features/procurement/pages/lpos/LPOListPage";
import LPOCreatePage from "#/features/procurement/pages/lpos/LPOCreatePage";
import LPOViewPage from "#/features/procurement/pages/lpos/LPOViewPage";
import GRNListPage from "#/features/procurement/pages/grns/GRNListPage";
import GRNCreatePage from "#/features/procurement/pages/grns/GRNCreatePage";
import GRNViewPage from "#/features/procurement/pages/grns/GRNViewPage";
import NCRListPage from "#/features/procurement/pages/ncrs/NCRListPage";
import NCRCreatePage from "#/features/procurement/pages/ncrs/NCRCreatePage";
import NCRViewPage from "#/features/procurement/pages/ncrs/NCRViewPage";
import SupplierListPage from "#/features/procurement/pages/suppliers/SupplierListPage";
import SupplierCreatePage from "#/features/procurement/pages/suppliers/SupplierCreatePage";
import SupplierViewPage from "#/features/procurement/pages/suppliers/SupplierViewPage";
import SupplierEditPage from "#/features/procurement/pages/suppliers/SupplierEditPage";
import PrequalListPage from "#/features/procurement/pages/suppliers/PrequalListPage";
import PrequalCreatePage from "#/features/procurement/pages/suppliers/PrequalCreatePage";
import PrequalViewPage from "#/features/procurement/pages/suppliers/PrequalViewPage";
import SupplierEvalListPage from "#/features/procurement/pages/suppliers/SupplierEvalListPage";
import SupplierEvalCreatePage from "#/features/procurement/pages/suppliers/SupplierEvalCreatePage";
import SupplierEvalViewPage from "#/features/procurement/pages/suppliers/SupplierEvalViewPage";
import FeedbackListPage from "#/features/procurement/pages/admin/FeedbackListPage";
import FeedbackCreatePage from "#/features/procurement/pages/admin/FeedbackCreatePage";
import FeedbackViewPage from "#/features/procurement/pages/admin/FeedbackViewPage";
import TenderListPage from "#/features/procurement/pages/admin/TenderListPage";
import TenderCreatePage from "#/features/procurement/pages/admin/TenderCreatePage";
import RiskListPage from "#/features/procurement/pages/admin/RiskListPage";
import RiskCreatePage from "#/features/procurement/pages/admin/RiskCreatePage";
import DelistingListPage from "#/features/procurement/pages/admin/DelistingListPage";
import DelistingCreatePage from "#/features/procurement/pages/admin/DelistingCreatePage";
import DelistingViewPage from "#/features/procurement/pages/admin/DelistingViewPage";

import EmailQueuePage from "#/features/admin/EmailQueuePage";

import HrRequisitionsMinePage from "#/features/requisitions/pages/RequisitionsPage";
import HrRequisitionCatalogPage from "#/features/requisitions/pages/RequisitionCatalogPage";
import HrRequisitionsInboxPage from "#/features/requisitions/pages/RequisitionApprovalsPage";
import HrRequisitionCreatePage from "#/features/requisitions/pages/RequisitionCreatePage";
import HrRequisitionViewPage from "#/features/requisitions/pages/RequisitionViewPage";
import HrRequisitionEditPage from "#/features/requisitions/pages/RequisitionEditPage";
import HrRequisitionFulfillmentPage from "#/features/requisitions/pages/RequisitionFulfillmentPage";
import HrRequisitionReportsPage from "#/features/requisitions/pages/RequisitionReportsPage";

import LeaveDashboardPage from "#/features/leave/pages/LeaveDashboardPage";
import LeaveRequestsPage from "#/features/leave/pages/LeaveRequestsPage";
import LeaveRequestCreatePage from "#/features/leave/pages/LeaveRequestCreatePage";
import LeaveRequestViewPage from "#/features/leave/pages/LeaveRequestViewPage";
import LeaveApprovalsPage from "#/features/leave/pages/LeaveApprovalsPage";
import LeaveBalancesPage from "#/features/leave/pages/LeaveBalancesPage";
import MyLeaveBalancesPage from "#/features/leave/pages/MyLeaveBalancesPage";
import MyLeavePage from "#/features/leave/pages/MyLeavePage";
import LeaveOnLeavePage from "#/features/leave/pages/LeaveOnLeavePage";
import OfficialDutyPage from "#/features/leave/pages/OfficialDutyPage";
import LeavePoliciesPage from "#/features/leave/pages/LeavePoliciesPage";
import LeaveYearPoliciesPage from "#/features/leave/pages/LeaveYearPoliciesPage";
import LeaveHolidayConfigPage from "#/features/leave/pages/LeaveHolidayConfigPage";
import LeaveEntitlementRulesPage from "#/features/leave/pages/LeaveEntitlementRulesPage";
import LeaveSetupPage from "#/features/leave/pages/LeaveSetupPage";
import LeavePlansPage from "#/features/leave/pages/LeavePlansPage";
import LeaveReportsPage from "#/features/leave/pages/LeaveReportsPage";
import LeaveApplicationFormPage from "#/features/leave/pages/LeaveApplicationFormPage";
import AssetDashboardPage from "#/features/assets/pages/AssetDashboardPage";
import AssetListPage from "#/features/assets/pages/AssetListPage";
import AssetDetailPage from "#/features/assets/pages/AssetDetailPage";
import AssetAddPage from "#/features/assets/pages/AssetAddPage";
import AssetEditPage from "#/features/assets/pages/AssetEditPage";
import AssetMyAssetsPage from "#/features/assets/pages/AssetMyAssetsPage";
import AssetAssignmentsPage from "#/features/assets/pages/AssetAssignmentsPage";
import AssetIssuancesPage from "#/features/assets/pages/AssetIssuancesPage";
import AssetDisposalPage from "#/features/assets/pages/AssetDisposalPage";
import AssetDisposalInboxPage from "#/features/assets/pages/AssetDisposalInboxPage";
import AssetImportPage from "#/features/assets/pages/AssetImportPage";
import AssetReportsPage from "#/features/assets/pages/AssetReportsPage";
import AssetSetupPage from "#/features/assets/pages/AssetSetupPage";
import PayrollDashboardPage from "#/features/payroll/pages/PayrollDashboardPage";
import PayrollPeriodsPage from "#/features/payroll/pages/PayrollPeriodsPage";
import PayrollPeriodDetailPage from "#/features/payroll/pages/PayrollPeriodDetailPage";
import PayrollImportPage from "#/features/payroll/pages/PayrollImportPage";
import PayslipsMinePage from "#/features/payroll/pages/PayslipsMinePage";
import PayslipDetailPage from "#/features/payroll/pages/PayslipDetailPage";
import PayrollStatutoryConfigPage from "#/features/payroll/pages/PayrollStatutoryConfigPage";
import PayrollDeductionCategoriesPage from "#/features/payroll/pages/PayrollDeductionCategoriesPage";
import PayrollEmployeeDeductionsPage from "#/features/payroll/pages/PayrollEmployeeDeductionsPage";
import PayrollBenefitCategoriesPage from "#/features/payroll/pages/PayrollBenefitCategoriesPage";
import PayrollEmployeeBenefitsPage from "#/features/payroll/pages/PayrollEmployeeBenefitsPage";
import PayrollBankAccountPage from "#/features/payroll/pages/PayrollBankAccountPage";
import PayrollMyBankAccountPage from "#/features/payroll/pages/PayrollMyBankAccountPage";
import PayrollReportsPage from "#/features/payroll/pages/PayrollReportsPage";

function UnauthorizedPage() {
  return (
    <div className="flex min-h-screen items-center justify-center px-4 text-center">
      <div>
        <h1 className="text-2xl font-bold text-slate-900">Unauthorized</h1>
        <p className="mt-2 text-sm text-slate-500">
          You do not have permission to access this page.
        </p>
      </div>
    </div>
  );
}

export const router = createBrowserRouter([
  {
    path: "/",
    element: <Navigate to="/dashboard" replace />,
  },
  {
    path: "/login",
    element: <LoginPage />,
  },
  {
    path: "/forgot-password",
    element: <ForgotPasswordPage />,
  },
  {
    path: "/reset-password",
    element: <ResetPasswordPage />,
  },
  {
    path: "/unauthorized",
    element: <UnauthorizedPage />,
  },

  {
    element: <ProtectedRoute />,
    children: [
      {
        element: <AppShell />,
        children: [
          {
            path: "/dashboard",
            element: <DashboardPage />,
          },
          {
            path: "/change-password",
            element: <ChangePasswordPage />,
          },
          {
            path: "/account/security",
            element: <AccountSecurityPage />,
          },

          {
            element: (
              <ProtectedRoute
                requiredRoles={["ADMIN", "SUPER_ADMIN"]}
                requiredPermissions={["HR_USER_VIEW", "HR_USER_MANAGE"]}
              />
            ),
            children: [
              {
                path: "/admin/users",
                element: <UsersPage />,
              },
              {
                path: "/admin/users/:userId",
                element: <UserViewPage />,
              },
            ],
          },

          {
            element: (
              <ProtectedRoute
                requiredRoles={["ADMIN", "SUPER_ADMIN"]}
                requiredPermissions={["HR_EMPLOYEE_VIEW", "HR_EMPLOYEE_MANAGE"]}
              />
            ),
            children: [
              {
                path: "/employees",
                element: <EmployeesPage />,
              },
              {
                path: "/employees/new",
                element: <EmployeeCreatePage />,
              },
              {
                path: "/employees/:employeeId",
                element: <EmployeeViewPage />,
              },
              {
                path: "/employees/:employeeId/edit",
                element: <EmployeeEditPage />,
              },
            ],
          },

          {
            element: (
              <ProtectedRoute
                requiredRoles={["SUPER_ADMIN"]}
                requiredPermissions={["HR_ROLE_VIEW", "HR_ROLE_MANAGE"]}
              />
            ),
            children: [
              {
                path: "/admin/roles",
                element: <RolesPage />,
              },
              {
                path: "/admin/roles/new",
                element: <RoleCreatePage />,
              },
              {
                path: "/admin/roles/:roleId",
                element: <RoleViewPage />,
              },
              {
                path: "/admin/roles/:roleId/edit",
                element: <RoleEditPage />,
              },
            ],
          },

          {
            element: (
              <ProtectedRoute
                requiredRoles={["SUPER_ADMIN"]}
                requiredPermissions={[
                  "HR_PERMISSION_VIEW",
                  "HR_PERMISSION_MANAGE",
                ]}
              />
            ),
            children: [
              {
                path: "/admin/permissions",
                element: <PermissionPage />,
              },
            ],
          },

          {
            element: (
              <ProtectedRoute
                requiredRoles={["SUPER_ADMIN"]}
                requiredPermissions={[
                  "HR_BUSINESS_CARD_VIEW",
                  "HR_BUSINESS_CARD_MANAGE",
                ]}
              />
            ),
            children: [
              {
                path: "/admin/business-cards",
                element: <BusinessCardPage />,
              },
            ],
          },

          {
            element: (
              <ProtectedRoute
                requiredRoles={["SUPER_ADMIN"]}
                requiredPermissions={[
                  "HR_CALENDAR_VIEW",
                  "HR_CALENDAR_MANAGE",
                ]}
              />
            ),
            children: [
              {
                path: "/admin/calendar",
                element: <CalendarAdminPage />,
              },
            ],
          },

          {
            element: (
              <ProtectedRoute
                requiredRoles={["SUPER_ADMIN"]}
                requiredPermissions={[
                  "HR_NOTICE_VIEW",
                  "HR_NOTICE_MANAGE",
                  "HR_NOTICE_APPROVE",
                ]}
              />
            ),
            children: [
              {
                path: "/admin/notices",
                element: <NoticeAdminPage />,
              },
            ],
          },

          {
            element: (
              <ProtectedRoute
                requiredRoles={["SUPER_ADMIN"]}
                requiredPermissions={["HR_AUDIT_VIEW", "HR_AUDIT_MANAGE"]}
              />
            ),
            children: [
              {
                path: "/admin/audit-log",
                element: <AuditLogPage />,
              },
            ],
          },

          {
            element: (
              <ProtectedRoute
                requiredPermissions={["EMAIL_QUEUE_VIEW"]}
              />
            ),
            children: [
              {
                path: "/admin/email-queue",
                element: <EmailQueuePage />,
              },
            ],
          },

          {
            element: (
              <ProtectedRoute
                requiredRoles={["ADMIN", "SUPER_ADMIN"]}
                requiredPermissions={["HR_WORKFLOW_VIEW", "HR_WORKFLOW_MANAGE"]}
              />
            ),
            children: [
              {
                path: "/admin/workflows",
                element: <WorkflowsPage />,
              },
              {
                path: "/admin/workflows/new",
                element: <WorkflowCreatePage />,
              },
              {
                path: "/admin/workflows/:workflowId",
                element: <WorkflowDetailsPage />,
              },
              {
                path: "/admin/workflows/:workflowId/edit",
                element: <WorkflowEditPage />,
              },
              {
                path: "/admin/workflow-delegations",
                element: <WorkflowDelegationsPage />,
              },
            ],
          },

          {
            element: (
              <ProtectedRoute
                requiredPermissions={[
                  "HR_LEAVE_VIEW",
                  "HR_LEAVE_APPLY",
                  "HR_LEAVE_APPROVE",
                  "HR_LEAVE_MANAGE",
                ]}
              />
            ),
            children: [
              { path: "/hr/leave",              element: <LeaveDashboardPage /> },
              { path: "/hr/leave/requests",     element: <LeaveRequestsPage /> },
              { path: "/hr/leave/requests/:id", element: <LeaveRequestViewPage /> },
              { path: "/hr/leave/my-balances",  element: <MyLeaveBalancesPage /> },
              { path: "/hr/leave/my-leave",     element: <MyLeavePage /> },
              { path: "/hr/leave/on-leave",       element: <LeaveOnLeavePage /> },
              { path: "/hr/leave/official-duty", element: <OfficialDutyPage /> },
            ],
          },

          {
            element: (
              <ProtectedRoute
                requiredPermissions={["HR_LEAVE_REPORT_VIEW", "HR_LEAVE_MANAGE"]}
              />
            ),
            children: [
              { path: "/hr/leave/reports", element: <LeaveReportsPage /> },
              // QR-code deep link from the application form PDF -- same permission gate as
              // the PDF download endpoint itself (see LeaveController.applicationFormPdf).
              { path: "/hr/leave/requests/:id/form", element: <LeaveApplicationFormPage /> },
            ],
          },

          {
            element: (
              <ProtectedRoute
                requiredPermissions={["HR_LEAVE_APPLY", "HR_LEAVE_MANAGE"]}
              />
            ),
            children: [
              { path: "/hr/leave/requests/new", element: <LeaveRequestCreatePage /> },
              { path: "/hr/leave/plans",        element: <LeavePlansPage /> },
            ],
          },

          {
            element: (
              <ProtectedRoute
                requiredPermissions={["HR_LEAVE_APPROVE", "HR_LEAVE_MANAGE"]}
              />
            ),
            children: [
              { path: "/hr/leave/approvals", element: <LeaveApprovalsPage /> },
            ],
          },

          {
            element: (
              <ProtectedRoute
                requiredPermissions={["HR_LEAVE_MANAGE"]}
              />
            ),
            children: [
              { path: "/hr/leave/setup",             element: <LeaveSetupPage /> },
              { path: "/hr/leave/policies",          element: <LeavePoliciesPage /> },
              { path: "/hr/leave/year-policies",     element: <LeaveYearPoliciesPage /> },
              { path: "/hr/leave/holidays",          element: <LeaveHolidayConfigPage /> },
              { path: "/hr/leave/entitlement-rules", element: <LeaveEntitlementRulesPage /> },
              { path: "/hr/leave/balances",          element: <LeaveBalancesPage /> },
            ],
          },

          {
            // My Assets — self-service, open to any authenticated employee (backend only
            // requires isAuthenticated() on GET /assets/my-assets). No permission needed.
            element: <ProtectedRoute />,
            children: [
              { path: "/assets/my-assets",        element: <AssetMyAssetsPage /> },
            ],
          },

          {
            // Asset Management — dashboard, catalog, assignments, issuances: anyone holding
            // any asset-management permission. Individual admin-only pages below are gated
            // tighter to match what the backend actually requires for each.
            element: (
              <ProtectedRoute
                requiredPermissions={[
                  "ASSET_VIEW", "ASSET_MANAGE", "ASSET_CREATE", "ASSET_EDIT", "ASSET_ASSIGN",
                  "ASSET_DISPOSE", "ASSET_DISPOSE_APPROVE", "ASSET_MAINTENANCE",
                  "ASSET_REPORT_VIEW", "ASSET_IMPORT",
                ]}
              />
            ),
            children: [
              { path: "/assets",                 element: <AssetDashboardPage /> },
              { path: "/assets/list",            element: <AssetListPage /> },
              { path: "/assets/:id",             element: <AssetDetailPage /> },
              { path: "/assets/assignments",     element: <AssetAssignmentsPage /> },
              { path: "/assets/issuances",       element: <AssetIssuancesPage /> },
            ],
          },

          {
            element: <ProtectedRoute requiredPermissions={["ASSET_CREATE", "ASSET_EDIT", "ASSET_MANAGE"]} />,
            children: [
              { path: "/assets/new",             element: <AssetAddPage /> },
              { path: "/assets/:id/edit",        element: <AssetEditPage /> },
            ],
          },

          {
            element: <ProtectedRoute requiredPermissions={["ASSET_DISPOSE", "ASSET_MANAGE"]} />,
            children: [
              { path: "/assets/disposals",       element: <AssetDisposalPage /> },
            ],
          },

          {
            element: <ProtectedRoute requiredPermissions={["ASSET_DISPOSE_APPROVE", "ASSET_MANAGE"]} />,
            children: [
              { path: "/assets/disposals/inbox", element: <AssetDisposalInboxPage /> },
            ],
          },

          {
            element: <ProtectedRoute requiredPermissions={["ASSET_IMPORT", "ASSET_MANAGE"]} />,
            children: [
              { path: "/assets/import",          element: <AssetImportPage /> },
            ],
          },

          {
            element: <ProtectedRoute requiredPermissions={["ASSET_REPORT_VIEW", "ASSET_MANAGE"]} />,
            children: [
              { path: "/assets/reports",         element: <AssetReportsPage /> },
            ],
          },

          {
            element: <ProtectedRoute requiredPermissions={["ASSET_MANAGE"]} />,
            children: [
              { path: "/assets/setup",           element: <AssetSetupPage /> },
            ],
          },

          {
            element: (
              <ProtectedRoute
                requiredPermissions={["PROCUREMENT_VIEW", "PROCUREMENT_CREATE", "PROCUREMENT_APPROVE", "PROCUREMENT_MANAGE"]}
              />
            ),
            children: [
              { path: "/procurement", element: <ProcurementDashboard /> },
              { path: "/procurement/reports", element: <ProcurementReportsPage /> },
              { path: "/procurement/requisitions", element: <RequisitionListPage /> },
              { path: "/procurement/requisitions/new", element: <RequisitionCreatePage /> },
              { path: "/procurement/requisitions/:id", element: <RequisitionViewPage /> },
              { path: "/procurement/rfqs", element: <RFQListPage /> },
              { path: "/procurement/rfqs/new", element: <RFQCreatePage /> },
              { path: "/procurement/rfqs/:id", element: <RFQViewPage /> },
              { path: "/procurement/evaluations", element: <EvaluationListPage /> },
              { path: "/procurement/evaluations/new", element: <EvaluationCreatePage /> },
              { path: "/procurement/evaluations/:id", element: <EvaluationViewPage /> },
              { path: "/procurement/lpos", element: <LPOListPage /> },
              { path: "/procurement/lpos/new", element: <LPOCreatePage /> },
              { path: "/procurement/lpos/:id", element: <LPOViewPage /> },
              { path: "/procurement/grns", element: <GRNListPage /> },
              { path: "/procurement/grns/new", element: <GRNCreatePage /> },
              { path: "/procurement/grns/:id", element: <GRNViewPage /> },
              { path: "/procurement/ncrs", element: <NCRListPage /> },
              { path: "/procurement/ncrs/new", element: <NCRCreatePage /> },
              { path: "/procurement/ncrs/:id", element: <NCRViewPage /> },
              { path: "/procurement/suppliers", element: <SupplierListPage /> },
              { path: "/procurement/suppliers/new", element: <SupplierCreatePage /> },
              { path: "/procurement/suppliers/:id", element: <SupplierViewPage /> },
              { path: "/procurement/suppliers/:id/edit", element: <SupplierEditPage /> },
              { path: "/procurement/supplier-prequal", element: <PrequalListPage /> },
              { path: "/procurement/supplier-prequal/new", element: <PrequalCreatePage /> },
              { path: "/procurement/supplier-prequal/:id", element: <PrequalViewPage /> },
              { path: "/procurement/supplier-eval", element: <SupplierEvalListPage /> },
              { path: "/procurement/supplier-eval/new", element: <SupplierEvalCreatePage /> },
              { path: "/procurement/supplier-eval/:id", element: <SupplierEvalViewPage /> },
              { path: "/procurement/admin/feedback", element: <FeedbackListPage /> },
              { path: "/procurement/admin/feedback/new", element: <FeedbackCreatePage /> },
              { path: "/procurement/admin/feedback/:id", element: <FeedbackViewPage /> },
              { path: "/procurement/admin/tenders", element: <TenderListPage /> },
              { path: "/procurement/admin/tenders/new", element: <TenderCreatePage /> },
              { path: "/procurement/admin/risks", element: <RiskListPage /> },
              { path: "/procurement/admin/risks/new", element: <RiskCreatePage /> },
              { path: "/procurement/admin/delistings", element: <DelistingListPage /> },
              { path: "/procurement/admin/delistings/new", element: <DelistingCreatePage /> },
              { path: "/procurement/admin/delistings/:id", element: <DelistingViewPage /> },
            ],
          },

          {
            element: (
              <ProtectedRoute
                requiredPermissions={[
                  "HR_REQUISITION_VIEW",
                  "HR_REQUISITION_CREATE",
                  "HR_REQUISITION_EDIT",
                  "HR_REQUISITION_APPROVE",
                  // Confirmed 2026-07-09 — Store Officers whose only requisition-related
                  // permission is the Fulfillment Queue's real gate would otherwise be blocked
                  // at this route group before ever reaching /hr/requisitions/fulfillment.
                  "HR_REQUISITION_FULFILL_STOCK",
                  // Finance and MD approvers act on requisitions from this same inbox
                  // (/hr/requisitions/inbox filters by role internally) but previously had
                  // no permission in this list, so a user who holds only one of these two
                  // was blocked by this route group before ever reaching the inbox.
                  "HR_FINANCE_APPROVE",
                  "HR_REQUISITION_MD_APPROVE",
                ]}
              />
            ),
            children: [
              { path: "/hr/requisitions/mine", element: <HrRequisitionsMinePage /> },
              { path: "/hr/requisitions/catalog", element: <HrRequisitionCatalogPage /> },
              { path: "/hr/requisitions/inbox", element: <HrRequisitionsInboxPage /> },
              { path: "/hr/requisitions/new", element: <HrRequisitionCreatePage /> },
              { path: "/hr/requisitions/fulfillment", element: <HrRequisitionFulfillmentPage /> },
              { path: "/hr/requisitions/reports", element: <HrRequisitionReportsPage /> },
              { path: "/hr/requisitions/:id", element: <HrRequisitionViewPage /> },
              { path: "/hr/requisitions/:id/edit", element: <HrRequisitionEditPage /> },
            ],
          },

          {
            element: (
              <ProtectedRoute
                requiredRoles={["ADMIN", "SUPER_ADMIN"]}
                requiredPermissions={[
                  "HR_INVENTORY_VIEW",
                  "HR_INVENTORY_CREATE",
                  "HR_INVENTORY_EDIT",
                  "HR_INVENTORY_MANAGE",
                  "HR_INVENTORY_APPROVE",
                  "HR_INVENTORY_ISSUE",
                  "HR_INVENTORY_IMPORT_MANAGE",
                ]}
              />
            ),
            children: [
              {
                path: "/inventory",
                element: <InventoryDashboardPage />,
              },
              {
                path: "/inventory/items",
                element: <InventoryItemsPage />,
              },
              {
                path: "/inventory/items/new",
                element: <InventoryItemCreatePage />,
              },
              {
                path: "/inventory/items/:id",
                element: <InventoryItemViewPage />,
              },
              {
                path: "/inventory/items/:id/edit",
                element: <InventoryItemEditPage />,
              },
              {
                path: "/inventory/import",
                element: <InventoryImportPage />,
              },
              {
                path: "/inventory/categories",
                element: <InventoryCategoriesPage />,
              },
              {
                path: "/inventory/reports",
                element: <InventoryReportsPage />,
              },
            ],
          },

          {
            // Payroll — no permission gate on the whole group; self-service pages (mine,
            // My Bank Account) are open to any authenticated employee. Individual pages/actions
            // gate further via HR_PAYROLL_VIEW/PROCESS/MANAGE/APPROVE (see PayrollDashboardPage
            // and each page's own useAuth() checks), same pattern as /assets.
            element: <ProtectedRoute />,
            children: [
              { path: "/payroll", element: <PayrollDashboardPage /> },
              { path: "/payroll/periods", element: <PayrollPeriodsPage /> },
              { path: "/payroll/periods/:id", element: <PayrollPeriodDetailPage /> },
              { path: "/payroll/periods/:id/import", element: <PayrollImportPage /> },
              { path: "/payroll/payslips/mine", element: <PayslipsMinePage /> },
              { path: "/payroll/payslips/:id", element: <PayslipDetailPage /> },
              { path: "/payroll/bank-account/mine", element: <PayrollMyBankAccountPage /> },
              { path: "/payroll/reports", element: <PayrollReportsPage /> },
              { path: "/payroll/config/statutory", element: <PayrollStatutoryConfigPage /> },
              { path: "/payroll/deduction-categories", element: <PayrollDeductionCategoriesPage /> },
              { path: "/payroll/employee-deductions", element: <PayrollEmployeeDeductionsPage /> },
              { path: "/payroll/benefit-categories", element: <PayrollBenefitCategoriesPage /> },
              { path: "/payroll/employee-benefits", element: <PayrollEmployeeBenefitsPage /> },
              { path: "/payroll/bank-accounts", element: <PayrollBankAccountPage /> },
            ],
          },

          {
            element: (
              <ProtectedRoute
                requiredRoles={["ADMIN", "SUPER_ADMIN"]}
              />
            ),
            children: [
              {
                path: "/admin/departments",
                element: <DepartmentsPage />,
              },
              {
                path: "/admin/departments/new",
                element: <DepartmentCreatePage />,
              },
              {
                path: "/admin/departments/:id/edit",
                element: <DepartmentEditPage />,
              },
            ],
          },

          {
            element: (
              <ProtectedRoute
                requiredRoles={["ADMIN", "SUPER_ADMIN"]}
                requiredPermissions={[
                  "HR_MEMBERSHIP_VIEW",
                  "HR_MEMBERSHIP_CREATE",
                  "HR_MEMBERSHIP_EDIT",
                  "HR_MEMBERSHIP_MANAGE",
                  "HR_MEMBERSHIP_REPORT_VIEW",
                ]}
              />
            ),
            children: [
              {
                path: "/hr/membership",
                element: <MembershipPortalPage />,
              },
              {
                path: "/hr/membership/create",
                element: <MemberCreatePage />,
              },
              {
                path: "/hr/membership/members/:memberId",
                element: <MemberDetailsPage />,
              },
              {
                path: "/hr/membership/members/:memberId/edit",
                element: <MemberEditPage />,
              },
              {
                path: "/hr/membership/config",
                element: <MembershipConfigPage />,
              },
              {
                path: "/hr/membership/upload",
                element: <MembershipUploadPage />,
              },
              {
                path: "/hr/membership/reports",
                element: <MembershipReportsPage />,
              },
              {
                path: "/hr/membership/manage",
                element: <MembershipManagePage />,
              },

            ],
          },

          {
            element: (
              <ProtectedRoute
                requiredRoles={["ADMIN", "SUPER_ADMIN"]}
                requiredPermissions={[
                  "HR_AIRTIME_VIEW",
                  "HR_AIRTIME_MANAGE",
                  "HR_AIRTIME_CONFIG_MANAGE",
                  "HR_AIRTIME_REPORT_VIEW",
                ]}
              />
            ),
            children: [
              {
                path: "/hr/airtime",
                element: <AirtimePortalPage />,
              },
              {
                path: "/hr/airtime/config",
                element: <AirtimeConfigPage />,
              },
              {
                path: "/hr/airtime/allocations",
                element: <AirtimeAllocationsPage />,
              },
              {
                path: "/hr/airtime/batches",
                element: <AirtimeBatchesPage />,
              },
            ],
          },

          {
            element: (
              <ProtectedRoute requiredPermissions={["HR_AIRTIME_VIEW"]} />
            ),
            children: [
              {
                path: "/hr/airtime/my-airtime",
                element: <AirtimeEmployeePage />,
              },
            ],
          },

          {
            element: (
              <ProtectedRoute
                requiredPermissions={[
                  "HR_CLAIM_VIEW",
                  "HR_CLAIM_CREATE",
                  "HR_CLAIM_EDIT",
                ]}
              />
            ),
            children: [
              {
                path: "/claims",
                element: <ClaimsDashboardPage />,
              },
              {
                path: "/claims/mine",
                element: <MyClaimsPage />,
              },
              {
                path: "/claims/new",
                element: <ClaimCreatePage />,
              },
              {
                path: "/claims/admin",
                element: <AdminClaimsPage />,
              },
              {
                path: "/claims/reports",
                element: <ClaimsReportsPage />,
              },
              {
                path: "/claims/approvals",
                element: <ClaimsApprovalPage />,
              },
              {
                path: "/claims/payment",
                element: <PaidClaimsPage />,
              },
              {
                path: "/claims/:id",
                element: <ClaimDetailsPage />,
              },
              {
                path: "/claims/:id/edit",
                element: <ClaimEditPage />,
              },
            ],
          },

          {
            path: "/notifications",
            element: <NotificationsPage />,
          },
          {
            path: "/notifications/inbox",
            element: <NotificationInboxPage />,
          },
          {
            path: "/approvals",
            element: <ApprovalInboxPage />,
          },

          { path: "/documents",    element: <DocumentsPage /> },
          { path: "/my-documents", element: <MyDocumentsPage /> },

          { path: "/hr/training",               element: <TrainingDashboardPage /> },
          { path: "/hr/training/mine",          element: <TrainingEnrollmentsPage /> },
          { path: "/hr/training/inbox",         element: <TrainingInboxPage /> },
          { path: "/hr/training/new",           element: <TrainingCourseCreatePage /> },
          { path: "/hr/training/:id",           element: <TrainingCourseViewPage /> },
          { path: "/hr/training/:id/edit",      element: <TrainingCourseEditPage /> },
          { path: "/hr/training/courses",       element: <TrainingCoursesPage /> },
          { path: "/hr/training/setup",              element: <TrainingSetupPage /> },
          { path: "/hr/training/programs",           element: <TrainingProgramsPage /> },
          { path: "/hr/training/programs/new",       element: <TrainingProgramCreatePage /> },
          { path: "/hr/training/programs/:id",       element: <TrainingProgramViewPage /> },

          {
            // Sessions/Attendance are HR_TRAINING_MANAGE-only in the backend (scheduling and
            // marking attendance, not something every employee should reach).
            element: <ProtectedRoute requiredPermissions={["HR_TRAINING_MANAGE"]} />,
            children: [
              { path: "/hr/training/sessions",    element: <TrainingSessionsPage /> },
              { path: "/hr/training/attendance",  element: <TrainingAttendancePage /> },
            ],
          },

          {
            // Org-wide Training Reports (financial totals, every employee's requests) — the
            // backend's listAll endpoint behind this page requires HR_TRAINING_VIEW specifically.
            element: <ProtectedRoute requiredRoles={["SUPER_ADMIN"]} requiredPermissions={["HR_TRAINING_VIEW"]} />,
            children: [
              { path: "/hr/training/reports",     element: <TrainingReportsPage /> },
            ],
          },

          {
            path: "*",
            element: <Navigate to="/dashboard" replace />,
          },
        ],
      },
    ],
  },
]);